export const SUPER = 'SUPER';
export const ADMINISTRATOR = 'ADMINISTRATOR';
export const USER = 'USER';
export const DISABLED = 'DISABLED';

export const ROLES = [SUPER, ADMINISTRATOR, USER, DISABLED];
